export default "__VITE_ASSET__BqMLT3GR__"